import React from 'react'
import {
    SEARCH_PARAMS_TAB_KEY,
    BASE_ABOUT_TAB_ID,
    BASE_ABOUT_TAB_LABEL,
    BASE_ABOUT_TAB_ID_LEGACY,
    BASE_AR_TAB_ID,
    BASE_AR_TAB_LABEL,
    BASE_HARDCODED_TAB_IDS,
    BASE_PHOTOS_TAB_ID,
    BASE_PHOTOS_TAB_LABEL,
    BASE_PRETRIP_TAB_ID,
    BASE_PRETRIP_TAB_LABEL,
} from '../constants/base-tab-links'
import Link from 'next/link'
import { cn, buildRegionAwareHref } from '../../../shared/lib/utils'
import { BASE_ROUTES } from '../../../shared/constants/pages-routes'
import { useRegion } from '@/shared/hooks/use-region'

interface BaseTabsProps {
    tabs: Array<{ id: string; label: string }>
    activeTab?: string
}

function BaseTabs({ tabs, activeTab }: BaseTabsProps) {
    const { regionSlug } = useRegion()

    // Hardcoded Photos, PreTrip, About, and AR tabs stay last in this order.
    const allTabs = [
        ...tabs.filter((t) => !BASE_HARDCODED_TAB_IDS.includes(t.id as (typeof BASE_HARDCODED_TAB_IDS)[number])),
        { id: BASE_PHOTOS_TAB_ID, label: BASE_PHOTOS_TAB_LABEL },
        { id: BASE_PRETRIP_TAB_ID, label: BASE_PRETRIP_TAB_LABEL },
        ...(tabs.some((t) => t.id === BASE_ABOUT_TAB_ID || t.id === BASE_ABOUT_TAB_ID_LEGACY)
            ? [{ id: BASE_ABOUT_TAB_ID, label: BASE_ABOUT_TAB_LABEL }]
            : []),
        ...(tabs.some((t) => t.id === BASE_AR_TAB_ID)
            ? [{ id: BASE_AR_TAB_ID, label: BASE_AR_TAB_LABEL }]
            : []),
    ]

    if (allTabs.length === 0) {
        return null
    }

    return (
        <div className="flex flex-nowrap items-center justify-center gap-2 overflow-x-auto sm:gap-5 sm:overflow-visible">
            {allTabs.map((tab, index) => {
                const href = buildRegionAwareHref(regionSlug ?? null, `${BASE_ROUTES.base}?${SEARCH_PARAMS_TAB_KEY}=${tab.id}`)
                const isActive = tab.id === activeTab || (!activeTab && index === 0)

                return (
                    <Link
                        key={tab.id}
                        href={href}
                        className={cn(
                            'shrink-0 whitespace-nowrap text-center text-sm pb-0.5 border-b-[3px] border-transparent sm:text-base',
                            {
                                "border-primary text-primary font-medium": isActive,
                            }
                        )}
                    >
                        {tab.label}
                    </Link>
                )
            })}
        </div>
    )
}

export default BaseTabs
